var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 262.499992",
    height: 350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a4ae273736"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.699219 91.699219 L 189.300781 91.699219 L 189.300781 170.300781 L 110.699219 170.300781 Z M 110.699219 91.699219 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4ae273736)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d5cde",
    d: "M 110.699219 91.699219 L 189.300781 91.699219 L 189.300781 170.300781 L 110.699219 170.300781 Z M 110.699219 91.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 283.242188 209.859375 C 283.242188 209.859375 16.628906 209.859375 16.628906 209.859375 C 12.652344 209.859375 9.429688 206.636719 9.429688 202.660156 C 9.429688 202.660156 9.429688 59.238281 9.429688 59.238281 C 9.429688 55.261719 12.652344 52.039062 16.628906 52.039062 C 16.628906 52.039062 283.242188 52.039062 283.242188 52.039062 C 287.21875 52.039062 290.441406 55.261719 290.441406 59.238281 C 290.441406 59.238281 290.441406 202.660156 290.441406 202.660156 C 290.441406 206.636719 287.21875 209.859375 283.242188 209.859375 Z M 283.242188 209.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 281.691406 201.960938 C 281.691406 201.960938 18.179688 201.960938 18.179688 201.960938 C 18.179688 201.960938 18.179688 59.941406 18.179688 59.941406 C 18.179688 59.941406 281.691406 59.941406 281.691406 59.941406 C 281.691406 59.941406 281.691406 201.960938 281.691406 201.960938 Z M 281.691406 201.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#76b9f0",
    d: "M 220.355469 194.082031 C 220.355469 194.082031 266.355469 194.082031 266.355469 194.082031 C 266.355469 194.082031 263.285156 157.121094 263.285156 157.121094 C 263.285156 157.121094 217.285156 157.121094 217.285156 157.121094 C 217.285156 157.121094 220.355469 194.082031 220.355469 194.082031 Z M 220.355469 194.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 217.241422, 157.077745)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 223.57822 46.419041 C 223.57822 46.419041 57.522875 46.419041 57.522875 46.419041 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 217.241422, 157.077745)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 223.57822 86.090052 C 223.57822 86.090052 57.522875 86.090052 57.522875 86.090052 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 217.241422, 157.077745)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 223.57822 125.761063 C 223.57822 125.761063 57.522875 125.761063 57.522875 125.761063 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 217.241422, 157.077745)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 104.029093 165.432073 C 84.059564 165.432073 67.619326 165.432073 60.85113 165.432073 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 89.15117, 100.34532)",
    fillOpacity: 1,
    fill: "#f2f2f2",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "M -103.236201 88.871064 C -103.236201 88.871064 117.992228 88.871064 117.992228 88.871064 C 117.992228 88.871064 103.227285 -88.866679 103.227285 -88.866679 C 103.227285 -88.866679 -118.001144 -88.866679 -118.001144 -88.866679 C -118.001144 -88.866679 -103.236201 88.871064 -103.236201 88.871064 Z M -103.236201 88.871064 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 101.601562 108.226562 C 101.601562 108.226562 88.71875 108.226562 88.71875 108.226562 C 88.175781 108.226562 87.730469 107.785156 87.730469 107.238281 C 87.730469 107.238281 87.730469 93.410156 87.730469 93.410156 C 87.730469 92.863281 88.175781 92.421875 88.71875 92.421875 C 88.71875 92.421875 101.601562 92.421875 101.601562 92.421875 C 102.144531 92.421875 102.589844 92.863281 102.589844 93.410156 C 102.589844 93.410156 102.589844 107.238281 102.589844 107.238281 C 102.589844 107.785156 102.144531 108.226562 101.601562 108.226562 Z M 101.601562 108.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 99.589844 108.226562 C 99.589844 108.226562 90.730469 108.226562 90.730469 108.226562 C 90.730469 108.226562 90.730469 104.03125 90.730469 104.03125 C 90.730469 101.585938 92.710938 99.601562 95.160156 99.601562 C 97.605469 99.601562 99.589844 101.585938 99.589844 104.03125 C 99.589844 104.03125 99.589844 108.226562 99.589844 108.226562 Z M 99.589844 108.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 97.613281 97.355469 C 97.613281 98.710938 96.515625 99.808594 95.160156 99.808594 C 93.804688 99.808594 92.707031 98.710938 92.707031 97.355469 C 92.707031 96 93.804688 94.902344 95.160156 94.902344 C 96.515625 94.902344 97.613281 96 97.613281 97.355469 Z M 97.613281 97.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 33.429688 166.878906 C 33.429688 166.878906 68.515625 166.878906 68.515625 166.878906 C 68.515625 166.878906 66.175781 138.6875 66.175781 138.6875 C 66.175781 138.6875 31.085938 138.6875 31.085938 138.6875 C 31.085938 138.6875 33.429688 166.878906 33.429688 166.878906 Z M 33.429688 166.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.174643, 0.00902616, -0.00902616, 0.174643, 51.571266, 150.135189)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.301295 17.983054 C 18.373074 33.616336 -2.346898 38.221219 -17.98018 28.292998 C -33.613462 18.364776 -38.240653 -2.354042 -28.290123 -17.988477 C -18.361902 -33.621759 2.358069 -38.226643 17.991351 -28.298421 C 33.624634 -18.370199 38.229517 2.349772 28.301295 17.983054 Z M 28.301295 17.983054 ",
    stroke: "#f2f2f2",
    strokeWidth: 16.731001,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174643, 0.00902616, -0.00902616, 0.174643, 45.487782, 158.69724)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 13.716472 -21.588454 C 13.716472 -21.588454 -13.733067 21.589602 -13.733067 21.589602 ",
    stroke: "#f2f2f2",
    strokeWidth: 16.731001,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 118.234375 133.140625 C 118.234375 133.140625 96.179688 133.140625 96.179688 133.140625 C 95.367188 133.140625 94.707031 133.800781 94.707031 134.613281 C 94.707031 134.613281 94.707031 152.40625 94.707031 152.40625 C 94.707031 153.222656 95.367188 153.878906 96.179688 153.878906 C 96.179688 153.878906 103.027344 153.878906 103.027344 153.878906 C 103.691406 153.878906 104.304688 154.234375 104.636719 154.808594 C 104.636719 154.808594 106.851562 158.644531 106.851562 158.644531 C 107.03125 158.957031 107.484375 158.957031 107.667969 158.644531 C 107.667969 158.644531 109.882812 154.808594 109.882812 154.808594 C 110.214844 154.234375 110.828125 153.878906 111.488281 153.878906 C 111.488281 153.878906 118.234375 153.878906 118.234375 153.878906 C 119.046875 153.878906 119.707031 153.222656 119.707031 152.40625 C 119.707031 152.40625 119.707031 134.613281 119.707031 134.613281 C 119.707031 133.800781 119.046875 133.140625 118.234375 133.140625 Z M 118.234375 133.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 105.921875 146.023438 C 105.675781 146.023438 105.484375 145.804688 105.523438 145.5625 C 105.671875 144.667969 106.238281 143.832031 107.152344 142.960938 C 108.226562 141.964844 108.78125 141.296875 108.777344 140.546875 C 108.777344 139.808594 108.109375 139.277344 107.378906 139.386719 C 106.75 139.476562 106.417969 139.902344 106.359375 140.859375 C 106.347656 141.050781 106.191406 141.203125 106 141.203125 C 106 141.203125 103.210938 141.203125 103.210938 141.203125 C 103.011719 141.203125 102.847656 141.039062 102.847656 140.839844 C 102.847656 137.816406 105.277344 136.09375 107.859375 136.09375 C 110.65625 136.09375 112.453125 138.140625 112.453125 140.148438 C 112.453125 141.453125 111.878906 142.484375 110.40625 143.785156 C 109.542969 144.566406 109.027344 145.128906 108.867188 145.738281 C 108.820312 145.910156 108.660156 146.023438 108.484375 146.023438 C 108.484375 146.023438 105.921875 146.023438 105.921875 146.023438 Z M 105.921875 146.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 105.488281 148.894531 C 105.488281 147.996094 106.214844 147.269531 107.113281 147.269531 C 107.113281 147.269531 107.191406 147.269531 107.191406 147.269531 C 108.089844 147.269531 108.816406 147.996094 108.816406 148.894531 C 108.816406 149.792969 108.089844 150.519531 107.191406 150.519531 C 107.191406 150.519531 107.113281 150.519531 107.113281 150.519531 C 106.214844 150.519531 105.488281 149.792969 105.488281 148.894531 Z M 105.488281 148.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#76b9f0",
    d: "M 100.324219 164.261719 C 100.324219 164.261719 74.3125 164.261719 74.3125 164.261719 C 73.355469 164.261719 72.578125 165.039062 72.578125 166 C 72.578125 166 72.578125 186.988281 72.578125 186.988281 C 72.578125 187.949219 73.355469 188.726562 74.3125 188.726562 C 74.3125 188.726562 82.386719 188.726562 82.386719 188.726562 C 83.171875 188.726562 83.894531 189.144531 84.285156 189.820312 C 84.285156 189.820312 86.898438 194.347656 86.898438 194.347656 C 87.113281 194.714844 87.648438 194.714844 87.859375 194.347656 C 87.859375 194.347656 90.472656 189.820312 90.472656 189.820312 C 90.863281 189.144531 91.585938 188.726562 92.371094 188.726562 C 92.371094 188.726562 100.324219 188.726562 100.324219 188.726562 C 101.285156 188.726562 102.0625 187.949219 102.0625 186.988281 C 102.0625 186.988281 102.0625 166 102.0625 166 C 102.0625 165.039062 101.285156 164.261719 100.324219 164.261719 Z M 100.324219 164.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 98.125 184.609375 C 98.125 184.609375 76.515625 184.609375 76.515625 184.609375 C 75.703125 184.609375 75.042969 183.949219 75.042969 183.136719 C 75.042969 183.136719 75.042969 172.027344 75.042969 172.027344 C 75.042969 171.21875 75.703125 170.558594 76.515625 170.558594 C 76.515625 170.558594 98.125 170.558594 98.125 170.558594 C 98.9375 170.558594 99.59375 171.21875 99.59375 172.027344 C 99.59375 172.027344 99.59375 183.136719 99.59375 183.136719 C 99.59375 183.949219 98.9375 184.609375 98.125 184.609375 Z M 98.125 184.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 87.319523, 180.346017)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 11.307178 7.358337 C 11.307178 7.358337 -11.320488 7.358337 -11.320488 7.358337 C -12.169304 7.358337 -12.839423 6.665881 -12.839423 5.817064 C -12.839423 5.817064 -12.839423 -5.820659 -12.839423 -5.820659 C -12.839423 -6.669476 -12.169304 -7.361931 -11.320488 -7.361931 C -11.320488 -7.361931 11.307178 -7.361931 11.307178 -7.361931 C 12.155994 -7.361931 12.84845 -6.669476 12.84845 -5.820659 C 12.84845 -5.820659 12.84845 5.817064 12.84845 5.817064 C 12.84845 6.665881 12.155994 7.358337 11.307178 7.358337 Z M 11.307178 7.358337 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 72.533599, 164.219844)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 14.349439 92.224377 C 14.349439 92.224377 71.711576 92.224377 71.711576 92.224377 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 72.533599, 164.219844)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 97.399449 92.224377 C 97.399449 92.224377 154.739248 92.224377 154.739248 92.224377 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.174876, 0, 0, 0.174876, 87.071193, 170.310767)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 16.234168 10.486093 C 16.234168 10.486093 -16.221901 10.486093 -16.221901 10.486093 C -20.063913 10.486093 -23.191132 7.358874 -23.191132 3.516861 C -23.191132 3.516861 -23.191132 -3.519382 -23.191132 -3.519382 C -23.191132 -7.361394 -20.063913 -10.488614 -16.221901 -10.488614 C -16.221901 -10.488614 16.234168 -10.488614 16.234168 -10.488614 C 20.07618 -10.488614 23.2034 -7.361394 23.2034 -3.519382 C 23.2034 -3.519382 23.2034 3.516861 23.2034 3.516861 C 23.2034 7.358874 20.07618 10.486093 16.234168 10.486093 Z M 16.234168 10.486093 ",
    stroke: "#f2f2f2",
    strokeWidth: 9.073,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 220.625 145.152344 C 220.625 145.152344 267.195312 145.152344 267.195312 145.152344 C 267.195312 145.152344 263.015625 75.800781 263.015625 75.800781 C 263.015625 75.800781 216.445312 75.800781 216.445312 75.800781 C 216.445312 75.800781 220.625 145.152344 220.625 145.152344 Z M 220.625 145.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 238.320312 98.113281 C 238.320312 98.113281 226.179688 98.113281 226.179688 98.113281 C 225.253906 98.113281 224.507812 97.363281 224.507812 96.441406 C 224.507812 96.441406 224.507812 83.3125 224.507812 83.3125 C 224.507812 82.390625 225.253906 81.640625 226.179688 81.640625 C 226.179688 81.640625 238.320312 81.640625 238.320312 81.640625 C 239.242188 81.640625 239.992188 82.390625 239.992188 83.3125 C 239.992188 83.3125 239.992188 96.441406 239.992188 96.441406 C 239.992188 97.363281 239.242188 98.113281 238.320312 98.113281 Z M 238.320312 98.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 236.867188 98.113281 C 236.867188 98.113281 227.632812 98.113281 227.632812 98.113281 C 227.632812 98.113281 227.632812 93.742188 227.632812 93.742188 C 227.632812 91.191406 229.699219 89.125 232.25 89.125 C 234.800781 89.125 236.867188 91.191406 236.867188 93.742188 C 236.867188 93.742188 236.867188 98.113281 236.867188 98.113281 Z M 236.867188 98.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 234.808594 86.78125 C 234.808594 88.195312 233.660156 89.339844 232.25 89.339844 C 230.835938 89.339844 229.691406 88.195312 229.691406 86.78125 C 229.691406 85.367188 230.835938 84.222656 232.25 84.222656 C 233.660156 84.222656 234.808594 85.367188 234.808594 86.78125 Z M 234.808594 86.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 237.378906 118.917969 C 237.378906 118.917969 227.996094 118.917969 227.996094 118.917969 C 227.285156 118.917969 226.703125 118.339844 226.703125 117.625 C 226.703125 117.625 226.703125 107.484375 226.703125 107.484375 C 226.703125 106.769531 227.285156 106.191406 227.996094 106.191406 C 227.996094 106.191406 237.378906 106.191406 237.378906 106.191406 C 238.09375 106.191406 238.671875 106.769531 238.671875 107.484375 C 238.671875 107.484375 238.671875 117.625 238.671875 117.625 C 238.671875 118.339844 238.09375 118.917969 237.378906 118.917969 Z M 237.378906 118.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 236.257812 118.917969 C 236.257812 118.917969 229.121094 118.917969 229.121094 118.917969 C 229.121094 118.917969 229.121094 115.542969 229.121094 115.542969 C 229.121094 113.570312 230.71875 111.972656 232.6875 111.972656 C 234.660156 111.972656 236.257812 113.570312 236.257812 115.542969 C 236.257812 115.542969 236.257812 118.917969 236.257812 118.917969 Z M 236.257812 118.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 234.664062 110.164062 C 234.664062 111.253906 233.78125 112.140625 232.6875 112.140625 C 231.597656 112.140625 230.710938 111.253906 230.710938 110.164062 C 230.710938 109.070312 231.597656 108.1875 232.6875 108.1875 C 233.78125 108.1875 234.664062 109.070312 234.664062 110.164062 Z M 234.664062 110.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 257.371094 138.3125 C 257.371094 138.3125 247.988281 138.3125 247.988281 138.3125 C 247.273438 138.3125 246.695312 137.734375 246.695312 137.019531 C 246.695312 137.019531 246.695312 126.878906 246.695312 126.878906 C 246.695312 126.164062 247.273438 125.585938 247.988281 125.585938 C 247.988281 125.585938 257.371094 125.585938 257.371094 125.585938 C 258.085938 125.585938 258.664062 126.164062 258.664062 126.878906 C 258.664062 126.878906 258.664062 137.019531 258.664062 137.019531 C 258.664062 137.734375 258.085938 138.3125 257.371094 138.3125 Z M 257.371094 138.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 256.25 138.3125 C 256.25 138.3125 249.109375 138.3125 249.109375 138.3125 C 249.109375 138.3125 249.109375 134.9375 249.109375 134.9375 C 249.109375 132.964844 250.707031 131.367188 252.679688 131.367188 C 254.652344 131.367188 256.25 132.964844 256.25 134.9375 C 256.25 134.9375 256.25 138.3125 256.25 138.3125 Z M 256.25 138.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 254.65625 129.558594 C 254.65625 130.648438 253.769531 131.53125 252.679688 131.53125 C 251.589844 131.53125 250.703125 130.648438 250.703125 129.558594 C 250.703125 128.464844 251.589844 127.582031 252.679688 127.582031 C 253.769531 127.582031 254.65625 128.464844 254.65625 129.558594 Z M 254.65625 129.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 76.154709 307.540993 C 76.154709 307.540993 134.343325 307.540993 134.343325 307.540993 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 76.154709 330.347356 C 76.154709 330.347356 134.343325 330.347356 134.343325 330.347356 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 167.067441 202.109027 C 167.067441 202.109027 225.256058 202.109027 225.256058 202.109027 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 167.067441 224.893054 C 167.067441 224.893054 225.256058 224.893054 225.256058 224.893054 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 167.067441 75.099249 C 167.067441 75.099249 225.256058 75.099249 225.256058 75.099249 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 216.401134, 75.757583)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 167.067441 97.883275 C 167.067441 97.883275 225.256058 97.883275 225.256058 97.883275 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 132.65625 193.847656 C 132.65625 193.847656 202.664062 191.402344 202.664062 191.402344 C 202.664062 191.402344 194.054688 87.328125 194.054688 87.328125 C 194.054688 87.328125 124.050781 89.773438 124.050781 89.773438 C 124.050781 89.773438 132.65625 193.847656 132.65625 193.847656 Z M 132.65625 193.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 142.199219 187.660156 C 142.199219 187.660156 212.207031 185.214844 212.207031 185.214844 C 212.207031 185.214844 203.597656 81.140625 203.597656 81.140625 C 203.597656 81.140625 133.589844 83.585938 133.589844 83.585938 C 133.589844 83.585938 142.199219 187.660156 142.199219 187.660156 Z M 142.199219 187.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 192.886719 136.816406 C 192.886719 136.816406 155.035156 138.140625 155.035156 138.140625 C 154.710938 138.148438 154.4375 137.894531 154.425781 137.566406 C 154.414062 137.242188 154.667969 136.964844 154.996094 136.957031 C 154.996094 136.957031 192.847656 135.632812 192.847656 135.632812 C 193.171875 135.621094 193.449219 135.878906 193.460938 136.203125 C 193.46875 136.53125 193.214844 136.804688 192.886719 136.816406 Z M 192.886719 136.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 193.132812 143.839844 C 193.132812 143.839844 155.28125 145.160156 155.28125 145.160156 C 154.957031 145.171875 154.679688 144.917969 154.667969 144.589844 C 154.65625 144.261719 154.914062 143.988281 155.242188 143.976562 C 155.242188 143.976562 193.09375 142.65625 193.09375 142.65625 C 193.417969 142.644531 193.691406 142.898438 193.703125 143.226562 C 193.714844 143.554688 193.460938 143.828125 193.132812 143.839844 Z M 193.132812 143.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 193.378906 150.863281 C 193.378906 150.863281 155.527344 152.183594 155.527344 152.183594 C 155.199219 152.195312 154.925781 151.9375 154.914062 151.613281 C 154.902344 151.285156 155.160156 151.011719 155.484375 151 C 155.484375 151 193.335938 149.679688 193.335938 149.679688 C 193.664062 149.667969 193.9375 149.921875 193.949219 150.25 C 193.960938 150.574219 193.707031 150.851562 193.378906 150.863281 Z M 193.378906 150.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 193.625 157.882812 C 193.625 157.882812 155.773438 159.207031 155.773438 159.207031 C 155.445312 159.21875 155.171875 158.960938 155.160156 158.632812 C 155.148438 158.308594 155.402344 158.035156 155.730469 158.023438 C 155.730469 158.023438 193.582031 156.699219 193.582031 156.699219 C 193.910156 156.6875 194.183594 156.945312 194.195312 157.273438 C 194.207031 157.597656 193.949219 157.871094 193.625 157.882812 Z M 193.625 157.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 193.867188 164.90625 C 193.867188 164.90625 156.019531 166.226562 156.019531 166.226562 C 155.691406 166.238281 155.417969 165.984375 155.40625 165.65625 C 155.394531 165.332031 155.648438 165.054688 155.976562 165.042969 C 155.976562 165.042969 193.828125 163.722656 193.828125 163.722656 C 194.15625 163.710938 194.429688 163.96875 194.441406 164.292969 C 194.453125 164.621094 194.195312 164.894531 193.867188 164.90625 Z M 193.867188 164.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M 194.113281 171.929688 C 194.113281 171.929688 156.261719 173.25 156.261719 173.25 C 155.9375 173.261719 155.660156 173.007812 155.652344 172.679688 C 155.640625 172.351562 155.894531 172.078125 156.222656 172.066406 C 156.222656 172.066406 194.074219 170.746094 194.074219 170.746094 C 194.398438 170.734375 194.671875 170.988281 194.683594 171.316406 C 194.695312 171.644531 194.441406 171.917969 194.113281 171.929688 Z M 194.113281 171.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#76b9f0",
    d: "M 183.0625 123.601562 C 183.0625 123.601562 160.191406 124.398438 160.191406 124.398438 C 159.015625 124.441406 158.023438 123.519531 157.984375 122.339844 C 157.984375 122.339844 157.125 97.742188 157.125 97.742188 C 157.082031 96.5625 158.007812 95.574219 159.183594 95.53125 C 159.183594 95.53125 182.054688 94.734375 182.054688 94.734375 C 183.230469 94.691406 184.222656 95.613281 184.261719 96.792969 C 184.261719 96.792969 185.121094 121.390625 185.121094 121.390625 C 185.160156 122.570312 184.242188 123.558594 183.0625 123.601562 Z M 183.0625 123.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 179.71875 123.71875 C 179.71875 123.71875 163.535156 124.28125 163.535156 124.28125 C 163.535156 124.28125 163.265625 116.621094 163.265625 116.621094 C 163.109375 112.152344 166.605469 108.402344 171.078125 108.246094 C 175.546875 108.089844 179.296875 111.585938 179.453125 116.054688 C 179.453125 116.054688 179.71875 123.71875 179.71875 123.71875 Z M 179.71875 123.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 175.414062 103.984375 C 175.5 106.460938 173.566406 108.535156 171.089844 108.625 C 168.617188 108.710938 166.539062 106.773438 166.453125 104.296875 C 166.367188 101.824219 168.300781 99.746094 170.777344 99.660156 C 173.25 99.574219 175.328125 101.511719 175.414062 103.984375 Z M 175.414062 103.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174769, -0.00610308, 0.00610308, 0.174769, 172.898348, 134.39905)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 157.128214 298.23557 C 157.128214 298.23557 214.502464 298.249893 214.502464 298.249893 C 214.502464 298.249893 186.070898 -298.237883 186.070898 -298.237883 C 186.070898 -298.237883 -214.501979 -298.234533 -214.501979 -298.234533 C -214.501979 -298.234533 -213.825892 -288.15302 -212.719916 -264.780063 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 201.65625 69.644531 C 200.671875 71.5 201.777344 74.015625 204.128906 75.265625 C 206.480469 76.515625 209.1875 76.027344 210.171875 74.171875 C 211.15625 72.320312 210.046875 69.804688 207.695312 68.554688 C 205.347656 67.304688 202.640625 67.792969 201.65625 69.644531 Z M 201.65625 69.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 202.046875 83.082031 C 202.046875 83.082031 197.671875 88.359375 197.671875 88.359375 C 197.53125 88.53125 197.25 88.394531 197.296875 88.175781 C 197.296875 88.175781 198.753906 81.378906 198.753906 81.378906 C 198.785156 81.226562 198.957031 81.160156 199.085938 81.242188 C 199.085938 81.242188 201.796875 83.054688 201.796875 83.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 194.714844 76.621094 C 193.332031 79.21875 195.25 82.9375 198.992188 84.929688 C 202.734375 86.917969 206.890625 86.425781 208.269531 83.828125 C 209.652344 81.230469 207.738281 77.511719 203.992188 75.523438 C 200.25 73.53125 196.09375 74.023438 194.714844 76.621094 Z M 194.714844 76.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 198.886719 78.839844 C 198.285156 79.972656 198.964844 81.511719 200.402344 82.277344 C 201.839844 83.042969 203.496094 82.742188 204.097656 81.609375 C 204.699219 80.476562 204.023438 78.9375 202.582031 78.171875 C 201.144531 77.40625 199.492188 77.707031 198.886719 78.839844 Z M 198.886719 78.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e8be8",
    d: "M 209.996094 74.457031 C 209.996094 74.457031 204.097656 81.609375 204.097656 81.609375 C 204.097656 81.609375 198.886719 78.839844 198.886719 78.839844 C 198.886719 78.839844 201.65625 69.644531 201.65625 69.644531 C 201.65625 69.644531 209.996094 74.457031 209.996094 74.457031 Z M 209.996094 74.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174769, -0.00610308, 0.00610308, 0.174769, 202.63753, 78.874869)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 26.7627 -5.501732 C 26.7627 -5.501732 8.228804 16.403104 8.228804 16.403104 C 8.228804 16.403104 -0.242641 26.656898 -13.934564 18.713566 C -26.772235 11.269434 -21.428371 -0.948701 -21.428371 -0.948701 C -21.428371 -0.948701 -12.685354 -26.659831 -12.685354 -26.659831 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174769, -0.00610308, 0.00610308, 0.174769, 205.004224, 73.524727)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M -18.358843 -22.842922 C -18.358843 -22.842922 -28.351205 -4.238303 -6.705748 8.92232 C 16.120242 22.839397 28.341782 6.324203 28.341782 6.324203 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#76b9f0",
    d: "M 40.109375 131.449219 C 40.109375 131.449219 86.109375 131.449219 86.109375 131.449219 C 86.109375 131.449219 83.039062 94.488281 83.039062 94.488281 C 83.039062 94.488281 37.039062 94.488281 37.039062 94.488281 C 37.039062 94.488281 40.109375 131.449219 40.109375 131.449219 Z M 40.109375 131.449219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 29.027824, 78.954778)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 269.139152 134.997073 C 269.139152 134.997073 103.083807 134.997073 103.083807 134.997073 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 29.027824, 78.954778)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 269.139152 174.668084 C 269.139152 174.668084 103.083807 174.668084 103.083807 174.668084 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 29.027824, 78.954778)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 269.139152 214.339094 C 269.139152 214.339094 103.083807 214.339094 103.083807 214.339094 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 29.027824, 78.954778)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 269.139152 254.010105 C 269.139152 254.010105 103.083807 254.010105 103.083807 254.010105 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 38.507812 81.210938 C 39.554688 83.027344 38.535156 85.578125 36.230469 86.910156 C 33.925781 88.242188 31.203125 87.847656 30.15625 86.03125 C 29.105469 84.214844 30.125 81.660156 32.429688 80.328125 C 34.738281 79 37.457031 79.390625 38.507812 81.210938 Z M 38.507812 81.210938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 38.585938 94.652344 C 38.585938 94.652344 43.140625 99.769531 43.140625 99.769531 C 43.289062 99.941406 43.566406 99.792969 43.511719 99.574219 C 43.511719 99.574219 41.816406 92.832031 41.816406 92.832031 C 41.78125 92.683594 41.605469 92.621094 41.480469 92.710938 C 41.480469 92.710938 38.832031 94.617188 38.832031 94.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 45.6875 87.9375 C 47.160156 90.484375 45.375 94.269531 41.703125 96.386719 C 38.03125 98.507812 33.863281 98.160156 32.390625 95.613281 C 30.921875 93.066406 32.703125 89.28125 36.375 87.164062 C 40.046875 85.042969 44.21875 85.390625 45.6875 87.9375 Z M 45.6875 87.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 41.59375 90.300781 C 42.234375 91.414062 41.613281 92.972656 40.203125 93.789062 C 38.792969 94.601562 37.128906 94.363281 36.484375 93.25 C 35.84375 92.140625 36.46875 90.578125 37.878906 89.761719 C 39.289062 88.949219 40.953125 89.1875 41.59375 90.300781 Z M 41.59375 90.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aeff",
    d: "M 30.339844 86.308594 C 30.339844 86.308594 36.484375 93.25 36.484375 93.25 C 36.484375 93.25 41.59375 90.300781 41.59375 90.300781 C 41.59375 90.300781 38.507812 81.210938 38.507812 81.210938 C 38.507812 81.210938 30.339844 86.308594 30.339844 86.308594 Z M 30.339844 86.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 37.848382, 90.466501)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M -26.764213 -5.504449 C -26.764213 -5.504449 -8.246607 16.408423 -8.246607 16.408423 C -8.246607 16.408423 0.241559 26.661235 13.934312 18.709163 C 26.755912 11.270849 21.417301 -0.947644 21.417301 -0.947644 C 21.417301 -0.947644 12.683425 -26.657854 12.683425 -26.657854 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.174876, 0, 0, 0.174876, 35.296424, 85.202214)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 18.363822 -22.823494 C 18.363822 -22.823494 28.348587 -4.238876 6.726099 8.917782 C -16.12494 22.833908 -28.343432 6.326657 -28.343432 6.326657 ",
    stroke: "#323232",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDescription);
export default __webpack_public_path__ + "static/media/JobDescription.fc4f1576298c08168f9aa6f58034c272.svg";
export { ForwardRef as ReactComponent };